<template>
  <div class="professional-result">
    <SameContent>
      <div v-if="loading" class="certificate">
        <Loading />
      </div>
      <div v-if="!loading" class="certificate">
        <div class="title">
          该证书授予
        </div>
        <img :src="`/${content.picpath}`" alt="" class="photo">
        <div class="base-message">
          <div class="item">
            姓名：{{ content.name }}
          </div>
          <div class="item">
            地区：{{ content.region }}
          </div>
          <div class="item">
            职称：{{ content.professional }}
          </div>
          <div class="item time">
            <div>认证期限：</div>
            <div>
              <p>{{ content.authenticationStartTime }} 至 </p>
              <p>{{ content.authenticationEndTime }}</p>
            </div>
          </div>
        </div>
        <div class="desc">
          {{ content.authenticationProduct }}
        </div>
        <div class="certificate-time">
          认证日期：{{ content.authenticationTime }}
        </div>
      </div>
    </SameContent>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
import SameContent from '@/components/SameContent'
import { queryRecognitionPerson } from '@/api/common'
export default {
  name: 'ProfessionalResult',
  components: {
    SameContent,
    Loading
  },
  data() {
    return {
      loading: false,
      content: {}
    }
  },
  mounted() {
    this.loading = true
    let code = this.$route.query.code
    if (code) {
      queryRecognitionPerson(code).then(res => {
        let { content, success, errorType } = res.data
        if (success && errorType === '00000000') {
          if (!content) {
            alert('您输入的专业人士信息不存在，谨防假冒。')
          } else {
            this.content = content
          }
        } else {
          alert('查询失败，请稍后再试！')
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
        alert('查询失败，请稍后再试！')
      })
    } else {
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.professional-result{
  width: 100%;
  height: 100%;
  position: relative;
  .certificate{
    width: 649px;
    height: 944px;
    background: url('~images/certificate-bg.png') no-repeat left top;
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    top: 230px;
    transform: translateX(-50%);
    .title{
      padding-top: 140px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(67, 138, 242, 0.6);
      text-align: center;
    }
    .photo{
      display: block;
      margin: 20px auto 0;
      width: auto;
      max-width: 383px;
      height: 183px;
      background-color: #ccc;
    }
    .base-message{
      padding-left: 129px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #171717;
      margin-top: 20px;
      .item{
        margin-top: 4px;
        &.time{
          display: flex;
          p:last-child{
            margin-top: 4px;
          }
        }
      }
    }
    .desc{
      position: absolute;
      bottom: 168px;
      left: 0;
      width: 100%;
      font-size: 23px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #438AF2;
      text-align: center;
    }
    .certificate-time{
      position: absolute;
      bottom: 90px;
      left: 0;
      width: 100%;
      height: 56px;
      line-height: 56px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
    }
  }
}
</style>
